import { create } from 'zustand'

export type ToastTone = 'info' | 'success' | 'error'

// bottom — операционные тосты (результат действия); top — событийные уведомления.
export type ToastPlacement = 'bottom' | 'top'

// Кнопка внутри тоста — undo для разрушительного/массового (docs/design §4:
// вместо диалога-подтверждения — тост с откатом, где это безопасно).
export interface ToastAction {
  label: string
  onClick: () => void
}

export interface ToastItem {
  id: string
  message: string
  tone: ToastTone
  placement: ToastPlacement
  action?: ToastAction
}

interface PushOptions {
  tone?: ToastTone
  ttlMs?: number
  placement?: ToastPlacement
  action?: ToastAction
}

interface ToastState {
  toasts: ToastItem[]
  push: (message: string, options?: PushOptions) => string
  dismiss: (id: string) => void
}

let counter = 0

export const useToastStore = create<ToastState>((set) => ({
  toasts: [],
  push: (message, { tone = 'info', ttlMs = 4000, placement = 'bottom', action } = {}) => {
    counter += 1
    const id = String(counter)
    set((s) => ({
      toasts: [...s.toasts, { id, message, tone, placement, ...(action ? { action } : {}) }],
    }))
    if (ttlMs > 0) {
      setTimeout(() => {
        set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }))
      }, ttlMs)
    }
    return id
  },
  dismiss: (id) => set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) })),
}))

// Императивный фасад для вызова из обработчиков вне компонентов.
export const toast = {
  info: (message: string) => useToastStore.getState().push(message),
  success: (message: string) => useToastStore.getState().push(message, { tone: 'success' }),
  error: (message: string) => useToastStore.getState().push(message, { tone: 'error' }),
  notify: (message: string) => useToastStore.getState().push(message, { placement: 'top' }),
  // Undo-тост разрушительного/массового: живёт дольше (5с), с кнопкой отката.
  undo: (message: string, onUndo: () => void, label = 'Отменить') =>
    useToastStore.getState().push(message, { ttlMs: 5000, action: { label, onClick: onUndo } }),
}
